export default __webpack_public_path__ + "static/media/logo-raw-removebg-preview.07010765.png";